module.exports = __webpack_public_path__ + "img/loginBanner.cd1c7ef6.svg";